const getters = {
  visibleColumns: state => state.columns.filter(x => x.showColumn),

  dateRange: state => state.dateRange,
};

export default getters;
